import React from "react";
import { DPPageWrapper } from "Components/DP";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";
import DataExchangeDashboardSection from "./DataExchangeDashboardSection/DataExchangeDashboardSection";
import OverviewSection from "./Overview/OverviewSection";

const DashboardPage = () => {
  const onPageLoad = () => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.HomePageViewed,
    });
  };

  return (
    <DPPageWrapper title="Dashboard" onPageLoad={onPageLoad}>
      <OverviewSection />
      <DataExchangeDashboardSection />
    </DPPageWrapper>
  );
};

export default DashboardPage;
